<template>
  <div id="app">
    <div class="containerea" v-show="$root.loading">
      <svg
        class="svgea"
        id="mainSVG"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="200 150 400 300"
      >
        <defs>
          <g id="container" filter="url(#goo)">
            <path class="seg" d="M412.9,251.7c-4.1-1.1-8.5-1.7-12.9-1.7" />
          </g>
          <filter
            id="goo"
            color-interpolation-filters="sRGB"
            filterUnits="objectBoundingBox"
            x="-100%"
            y="-100%"
            width="250%"
            height="250%"
          >
            <feGaussianBlur in="SourceGraphic" stdDeviation="8" result="blur" />
            <feColorMatrix
              in="blur"
              mode="matrix"
              values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 21 -9"
              result="cm"
            />
            <feBlend />
          </filter>
          <radialGradient
            id="grad"
            cx="400.5176"
            cy="298.0287"
            r="125.9247"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.39" style="stop-color: #0b62ab" />
            <stop offset="0.45" style="stop-color: #005297" />
          </radialGradient>
        </defs>
        <g id="wrapper">
          <use
            x="13"
            y="13"
            xlink:href="#container"
            fill="none"
            stroke-width="13"
            stroke-miterlimit="10"
            stroke-linejoin="round"
            stroke-linecap="round"
            stroke="#5B1E00"
            opacity="0.05"
          />
          <use
            xlink:href="#container"
            fill="none"
            stroke-width="13"
            stroke-miterlimit="10"
            stroke-linejoin="round"
            stroke-linecap="round"
            stroke="url(#grad)"
          />
        </g>
      </svg>
    </div>
    <component :is="layout" v-if="$root.loading === false">
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </component>
    <VueLoadingOverlay :active.sync="$root.loadingMx" :is-full-page="true">
    </VueLoadingOverlay>
  </div>
</template>

<script>
import gsap from 'gsap'
const default_layout = 'default'

export default {
  name: 'AppLayout',
  computed: {
    layout () {
      return (this.$route.meta.layout || default_layout) + '-layout'
    }
  },
  mounted () {
    const select = (s) => document.querySelector(s)
    const container = select('#container')
    const seg = select('.seg')
    const allSegs = []

    gsap.set('svg', {
      visibility: 'visible'
    })
    const num = 360 / 15
    const duration = 0.25
    allSegs.push(seg)

    for (var i = 1; i < num - 8; i++) {
      const clone = seg.cloneNode(true)
      container.appendChild(clone)
      gsap.set(clone, {
        rotation: i * 15,
        svgOrigin: '400 300'
      })
      allSegs.push(clone)
    }
    const mainTl = gsap.timeline({})

    allSegs.forEach((item, count) => {
      const tl = gsap.timeline()
      tl.to(item, {
        rotation: '-=120',
        svgOrigin: '400 300',
        repeat: -1,
        repeatRefresh: true,
        ease: 'sine.inOut',
        repeatDelay: (num - 10) * duration
      })
      mainTl.add(tl, count * duration)
    })

    gsap.to(
      container,
      {
        duration: 1,
        rotation: 360,
        svgOrigin: '400 300',
        ease: 'linear',
        repeat: -1
      },
      0
    )

    gsap.globalTimeline.timeScale(0.5)
  }
}
</script>
<style>
.svgea {
  width: 260px;
  height: 260px;
  visibility: hidden;
}
.containerea {
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
